import { useEffect, useMemo, useRef } from "react";
import { useQuery } from "react-query";
import { listVirtualOfficeHighlights } from "../../api/client";
import { markHighlightSeen, unwrapHighlights } from "./voHighlights";

export function useVoFloorHighlights({
  enabled = false,
  roomId = 0,
  onFresh,
} = {}) {
  const voId = Number(roomId) || 0;
  const { data, refetch } = useQuery(
    ["vo-floor-highlights", voId],
    () => listVirtualOfficeHighlights(voId),
    {
      enabled: Boolean(enabled && voId),
      refetchInterval: 90_000,
      staleTime: 45_000,
    }
  );
  const items = useMemo(() => unwrapHighlights(data), [data]);
  const onFreshRef = useRef(onFresh);
  onFreshRef.current = onFresh;

  useEffect(() => {
    if (typeof window === "undefined") return;
    let shown = 0;
    for (const item of items) {
      if (!item.fresh) continue;
      if (!markHighlightSeen(window.sessionStorage, item)) continue;
      if (shown >= 2) continue;
      try {
        onFreshRef.current?.(item);
        shown += 1;
      } catch {
        /* ignore */
      }
    }
  }, [items]);

  return { items, refetch };
}
